import FIMenuPaymentAmount from '@core/classes/FIMenuPaymentAmount';

const LenderHelper = {
	getTermFIMenuPaymentAmount(dealTerm, coverageTermTerm, finalNumbers, sellRate, buyRate) {
		const paymentAmount = new FIMenuPaymentAmount({
			amountFinanced: finalNumbers.finalAmount,
			dealTerm: dealTerm,
			coverageTerm: coverageTermTerm,
			sellRate: sellRate,
			paymentAtSellRate: finalNumbers.finalPayment,
			paymentAtSellRateWithTax: finalNumbers.finalPayment,
			buyRate: buyRate,
			paymentAtBuyRate: finalNumbers.finalPaymentAtBuyRate,
			paymentAtBuyRateWithTax: finalNumbers.finalPaymentAtBuyRate,
		});

		return paymentAmount;
	},
};

export default LenderHelper;
